// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".choiceCard{display:flex;align-items:center;justify-content:flex-start;background:#fff;padding:2rem 2.5rem;grid-gap:1em;gap:1em;border-radius:8px;box-shadow:0 5px 45px 10px rgba(0,0,0,.2);width:100%;cursor:pointer;transition:transform .5s ease}.choiceCard img{height:2em}.choiceCard-title{margin:0;font-weight:300;letter-spacing:.25rem}@media(max-width:1000px){.choiceCard-title{font-size:1.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
